module.exports = __webpack_public_path__ + "img/footer-youtobe.182c283f.svg";